'use client';

import React from 'react';

interface BasicLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  required?: boolean;
}

export const BasicLabel: React.FC<BasicLabelProps> = ({ label, required, ...props }) => {
  return (
    <div style={{ textAlign: 'start' }} {...props}>
      <div style={{ fontSize: '14px', fontWeight: '600', color: '#2F2F35' }}>
        {label}
        {required && <span style={{ color: '#DE3E47' }}>*</span>}
      </div>
    </div>
  );
};
